import { useEffect, useState } from "react";

// this is the only reliable way to get MapCanvasProjection
// other methods only seem legit, but can return undefined
// unexpectedly
const useMapCanvasProjection = (
  map: google.maps.Map
): google.maps.MapCanvasProjection | undefined => {
  const [projection, setProjection] = useState<google.maps.MapCanvasProjection | undefined>();

  useEffect(() => {
    class ProjectionGetterOverlay extends google.maps.OverlayView {
      onAdd() {
        setProjection(this.getProjection());
      }
      draw() {}
      onRemove() {}
    }

    const overlay = new ProjectionGetterOverlay();
    overlay.setMap(map);
    return () => {
      overlay.setMap(null);
    };
  }, [map]);

  return projection;
};

export default useMapCanvasProjection;
